import axios from 'axios';
import toastr from 'toastr';
import config from '../../config/index';
import routes from '../../constants/routes';
import { ADD_BVN_DETAILS, VERIFY_ADD_BVN_ISLOADING } from '../types';
import logoutAction from '../auth.actions/logout.action';

export const addBvnDetail = AddBvnDetails => ({
  type: ADD_BVN_DETAILS,
  AddBvnDetails
});

const verifyAddBvnLoading = () => ({
  type: VERIFY_ADD_BVN_ISLOADING
});

const addBvnDetailsRequest = addBvnDetails => (dispatch) => {
  dispatch(verifyAddBvnLoading());
  return axios.post(`${config.apiUrl}${routes.ADDBVN}`, addBvnDetails).then((response) => {
    dispatch(verifyAddBvnLoading());
    console.log('add-bvn', response);
    const { responseMessage } = response.data;
    dispatch(addBvnDetail(response.data));
    toastr.success(responseMessage);
  }).catch((error) => {
    dispatch(verifyAddBvnLoading());
    if (error.response === undefined) {
      window.location.href = '/error';
    }
    if (error.response.status === 401) {
      const { status } = error.response;
      dispatch(logoutAction(status));
    }
    throw error;
  });
};

export default addBvnDetailsRequest;
